import { render, staticRenderFns } from "./DetalhesAtendimento.vue?vue&type=template&id=0165fa72"
import script from "./DetalhesAtendimento.vue?vue&type=script&lang=ts"
export * from "./DetalhesAtendimento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports